import {DateDiv} from "./DateDiv";
import React, {useEffect, useState} from "react";
import {GetAvailableAppointmentsRequest, IClientServiceProto, space} from "../../../compiled";
import '../BookingOverlay.css';
import {useSearchParams} from "react-router-dom";
import {WeekAdjuster} from "../WeekAdjuster";
import {useGetAppointmentSchedule} from "../../../util/RpcHooks/GetAppointmentSchedule";
import {LoadingDots} from "../../../util/UI/LoadingDots";
import moment from "moment/moment";
import IPractitionerProto = space.kenko.proto.IPractitionerProto;

interface Props {
  businessId: string;
  practitionerId: string,
  serviceSku: string;
  onSelected: (timestamp: number) => void;
}

export const ChooseTime = (props: Props) => {

  const [searchParams] = useSearchParams();
  const version = searchParams.get('v') ?? undefined; // this is for previewing your flow

  const appointmentScheduleRpc = useGetAppointmentSchedule();
  
  // N weeks in the future; shouldn't be less than 0 or greater than say, 4.
  const [week, setWeek] = useState(0);

  useEffect(() => {
    appointmentScheduleRpc.send(new GetAvailableAppointmentsRequest({
          businessId: props.businessId,
          profileVersion: version,
          fromTimestampMs: getStartTimestamp(),
          toTimestampMs: getEndTimestamp(),
          sku: props.serviceSku,
          practitionerId: props.practitionerId
        }));
  }, [week])

  // The response is just a list of numbers. This categorizes them by date
  // in the local time zone.
  const splitByDate = (dates: Date[] | undefined): Date[][] => {
    if (!dates) {
      return [];
    }

    var subarrays: Date[][] = [];
    var startIndex = 0;
    for (let i = 0; i < dates.length; i++) {

      if (dates[i].getDate() != dates[startIndex].getDate()) {

        // This position in the array has a different date than the last position
        // in the array. Add a new subarray to the return value.
        // Note this is a shallow copy which is very good!
        subarrays.push(dates.slice(startIndex, i));
        startIndex = i;
      }
    }

    if (startIndex < dates.length) {
      subarrays.push(dates.slice(startIndex));
    }

    return subarrays;
  }

  // These get the start and end timestamps for the available times query; it should be
  // 0h00 on the first day chosen and 24h00 on the last day chosen.
  const getStartTimestamp = () => {
    // Don't go before NOW to get times. TODO -- server enforcement
    return Math.max(new Date().getTime(), moment().startOf('day').add(week, 'weeks').valueOf());
  }

  const getEndTimestamp = () => {
    return moment().endOf('day').add(week, 'weeks').add(6, 'days').valueOf();
  }

  return (<>
    
    <WeekAdjuster week={week} onWeekChange={setWeek}/>

    {appointmentScheduleRpc.response?.availableTimes?.map(value => {
      const provider = value.provider as IPractitionerProto;
      const availableTimes = value.availableTimes
      const dates = availableTimes?.map(value => new Date(value as number));
      const dateSubArrays = splitByDate(dates) || null;

      return <div key={value.provider?.practitionerId as string}
                  style={{textAlign: 'start'}}>
        <h3 style={{marginTop: 0}}>{provider.firstName + ' ' + provider.lastName}</h3>
        {dateSubArrays?.map((dateSubArray, idx) => {
          return <DateDiv key={'datesub-' + idx}
                          dates={dateSubArray}
                          service={appointmentScheduleRpc?.response?.service as IClientServiceProto}
                          onTimeSelected={props.onSelected}/>
        })}
      </div>
    })}

    {appointmentScheduleRpc.rpcState.state == 'pending' && <div>Loading available times<LoadingDots/></div>}
    {appointmentScheduleRpc.rpcState.state == 'error' &&
        <div className={'ErrorText'}>{appointmentScheduleRpc.rpcState.message}</div>}
    {appointmentScheduleRpc.rpcState.state == 'success' &&
        !appointmentScheduleRpc.response?.availableTimes?.length &&
        <h3>Sorry, no available times slots found! Please try a different week.</h3>}
    
  </>);
}